import { Recipient } from "@accurx/api/content";

import {
    MAX_BODY_LENGTH,
    SUPPORTED_PLACEHOLDERS,
} from "./ManageTemplatesFormPage.helpers";

const getUnsupportedPlaceholders = (
    content: string,
    recipientType: Recipient,
): string[] => {
    const placeholderRegex = /%([A-Z0-9_]+)%/g;
    const contentInPlaceholderFormat = [
        ...(content.match(placeholderRegex) || []),
    ];

    if (recipientType === Recipient.Patient) {
        return contentInPlaceholderFormat;
    }

    return contentInPlaceholderFormat.filter(
        (placeholder) =>
            !SUPPORTED_PLACEHOLDERS.some((option) => option.id === placeholder),
    );
};

export const validateMessageBody = (
    body: string,
    recipient: Recipient,
): string[] => {
    const errors = [];

    if (body.length === 0) {
        const errorMessage = "Message can't be empty";
        errors.push(errorMessage);
    } else if (
        body.length > MAX_BODY_LENGTH &&
        recipient === Recipient.Patient
    ) {
        const errorMessage =
            "Message including intro and signature can't be more than 612 characters long";
        errors.push(errorMessage);
    }

    const unsupportedPlaceholders = getUnsupportedPlaceholders(body, recipient);

    if (unsupportedPlaceholders.length > 0) {
        const validFormat = unsupportedPlaceholders
            .map(
                (placeholder: string) =>
                    `***${placeholder.replace(/%/g, "")}***`,
            )
            .join(", ");
        const errorMessage = `You've included the following in your template: ${unsupportedPlaceholders.join(
            ", ",
        )}. We use this format in some types of template to automatically fill information from the medical record. Please write your placeholder as ${validFormat} instead.`;
        errors.push(errorMessage);
    }

    return errors;
};
